export default "__VITE_ASSET__DFrr8FD9__"